(() => {
  if (window.__steryeHorrorOctober) return;
  window.__steryeHorrorOctober = true;
  const shipAt = Date.parse('2026-10-20T00:00:00-05:00');
  const deadline = Date.parse('2026-10-24T00:00:00-05:00');
  let config;
  let selectedVariant;

  const setText = (node, value) => {
    if (node && node.textContent !== value) node.textContent = value;
  };
  const getVariant = () => {
    const chosenTier = document.querySelector('.horror-box-variant-cards input:checked');
    const tier = chosenTier?.dataset.horrorTier || 'small';
    const form = document.querySelector('.product__info-container form[action*="/cart/add"]');
    const id = selectedVariant?.id || form?.querySelector('[name="id"]')?.value;
    return config.variants.find(v => String(v.id) === String(id) && v.tier === tier) || config.variants.find(v => v.tier === tier);
  };
  const update = () => {
    if (!config) return;
    const now = Date.now();
    const beforeShip = now < shipAt;
    const variant = getVariant();
    const ultimate = variant?.tier === 'ultimate';
    document.querySelectorAll('[data-horror-shipping-message]').forEach(node => {
      const all = node.dataset.horrorShippingMode === 'all';
      setText(node, beforeShip && all ? config.shippingAll : beforeShip && ultimate && !all ? config.shippingUltimate : config.shippingRegular);
    });
    document.querySelectorAll('[data-horror-before-ship]').forEach(node => node.hidden = !beforeShip);
    document.querySelectorAll('[data-horror-offer]').forEach(node => node.hidden = !beforeShip);
    document.querySelectorAll('[data-horror-seasonal]').forEach(root => {
      const offer = root.querySelector('[data-horror-selected-offer]');
      offer.hidden = !beforeShip || !variant?.hasOffer || !ultimate || !variant?.available;
      setText(root.querySelector('[data-horror-offer-price]'), variant?.offerPrice || '');
      setText(root.querySelector('[data-horror-offer-terms]'), variant?.offerTerms || '');
      const block = root.querySelector('[data-horror-deadline]');
      const remaining = deadline - now;
      block.hidden = remaining <= 0;
      if (remaining > 0) {
        const minutes = Math.ceil(remaining / 60000);
        setText(root.querySelector('[data-ho-days]'), String(Math.floor(minutes / 1440)).padStart(2, '0'));
        setText(root.querySelector('[data-ho-hours]'), String(Math.floor(minutes % 1440 / 60)).padStart(2, '0'));
        setText(root.querySelector('[data-ho-minutes]'), String(minutes % 60).padStart(2, '0'));
        root.querySelector('[data-horror-clock]').hidden = false;
      }
    });
  };
  const initialize = () => {
    const data = document.querySelector('[data-horror-october-config]');
    if (!data) return;
    config = JSON.parse(data.textContent);
    update();
  };
  document.addEventListener('change', event => {
    if (event.target.closest('variant-selects')) {
      selectedVariant = null;
      requestAnimationFrame(update);
    }
  });
  document.addEventListener('variant:change', () => requestAnimationFrame(update));
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  window.addEventListener('pageshow', update);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      selectedVariant = event.data?.variant;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.setInterval(update, 1000);
})();
